/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { getSrc } from 'gatsby-plugin-image'
import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import ContentfulButtonV3 from '../Utilities/Buttons/V3/ContentfulButtonV3'
import HeadlineBlockCard from './HeadlineBlockCard'
import BlockCardImage from './BlockCardImage'
import { textAligner, boxAligner } from '../../helpers/stylesAligner'
import { noPaddingCard, backgroundColorDiv, hideImageMobileClass } from '../../helpers/imageOptions'
import { quotesConverter } from '../../helpers/quotesConverter'
// import { convertOldToNewBlogCategories } from '../../helpers/blogCategoriesConverter'
import '../../sass/mainv3.scss'
import { renderRawHack } from '../Utilities/RichTextRenderer'
import { subtextOptions, contactHourOptions } from '../Utilities/DocumentToReactOptions'

function BlockCardV3({
  data,
  useDivOutterContainer,
  grid,
  columns,
  blog,
  showcaseCircles,
  cardNumber,
  quote,
  imageGrid,
  gridLeadershipDesign,
  ods
}) {
  const {
    theme,
    headline,
    hideImageMobile,
    backgroundImage,
    backgroundImageMobile,
    alignTextContent,
    alignTextContentMobile,
    buttons,
    afterText,
    disclaimerText,
    contactHoursText,
    isBlog,
    decorationBlockCard,
    mobileImageLocation,
    activeLetsTalkDesign,
    activeLeadershipDesign,
    postTitle,
    featuredImage,
    __typename,
    categories = [],
    slug,
    sys = {}
  } = data

  const { contentType } = sys
  let category = categories[0]
  if (category) {
    // category = convertOldToNewBlogCategories(category)
    category = category.toLowerCase().replace('@', '')
  }

  let { images, subText, subHeadline, blockCardBox } = data
  const { link = { url: `/v3/blog/${category}/${slug}`, title: ' READ MORE' } } = data
  const [document, setDocument] = useState(null)
  const [openDiv, setOpenDiv] = useState(false)

  const contentAlignClass = alignTextContent && alignTextContent.toLowerCase()
  const blogTextColorClass = blog ? 'white' : ''
  const hasImageClass = `${images ? 'has' : 'no'}-image`
  const sectionHeroPadding = backgroundImage || backgroundImageMobile ? 'section-hero-pd' : ''
  const contentAlignClassMobile =
    alignTextContentMobile && alignTextContentMobile !== null
      ? alignTextContentMobile.toLowerCase()
      : 'left'

  let buttonClass
  if (isBlog || blog) {
    buttonClass = 'button-visit-blog'
  }
  if (columns === 'grid-two-columns') {
    buttonClass = 'button-two-columns'
  }
  // in the two columns left wider grid all the buttons inside the cards
  // located on the left will have a different width
  if (columns === 'grid-two-columns-left-wider' && cardNumber % 2 === 0) {
    buttonClass = 'button-smaller'
  }

  /* eslint-disable react/no-danger */
  let headlineComp
  let showcaseTitleComp
  if (__typename === 'ContentfulTestingBlogPost' || contentType?.sys?.id === 'testingBlogPost') {
    subText = renderRawHack(data.postBody)
    subHeadline = postTitle
    images = featuredImage
    blockCardBox = true
  }
  if (headline && headline.trim().length) {
    if (imageGrid && getSrc(imageGrid.image)) {
      headlineComp = (
        <HeadlineBlockCard
          isGridHeadline
          text={headline}
          alignText={alignTextContent}
          gridLeadershipDesign={gridLeadershipDesign}
          blockcardLeadershipDesing={activeLeadershipDesign}
        />
      )
    } else {
      headlineComp = (
        <HeadlineBlockCard
          isGridHeadline={false}
          text={headline}
          alignText={alignTextContent}
          gridLeadershipDesign={gridLeadershipDesign}
          blockcardLeadershipDesing={activeLeadershipDesign}
        />
      )
    }
  }

  let subHeadlineComp
  if (subHeadline && subHeadline.trim().length) {
    subHeadlineComp = (
      <p
        className="subtitle"
        dangerouslySetInnerHTML={{
          __html: subHeadline
        }}
      />
    )
    showcaseTitleComp = (
      <p
        className="showcase-card-title"
        dangerouslySetInnerHTML={{
          __html: subHeadline
        }}
      />
    )
  }

  let subTextClass

  if (subText) {
    subTextClass = 'subtext'
  }
  if (subText && showcaseCircles) {
    subTextClass = 'showcase-card-subtext'
  }
  if (subText && quote) {
    subTextClass = 'phrase'
  }

  let blogLink
  if (isBlog || blog) {
    blogLink = (
      <span>
        <Link className="post-link" to={link?.url || '#'} data-event="press">
          {/* TODO: Update to use actual title - hardcoding pre v3 launch  */}
          {' Read More'}
          {/* {link?.title} */}
        </Link>
      </span>
    )
  }

  const toggleCollapseClass = () => {
    setOpenDiv(state => !state)
  }

  const moreLessLabel = () => {
    if (openDiv) {
      return <p>Read Less</p>
    }
    return <p>Read More</p>
  }

  let readMoreLink
  if (gridLeadershipDesign) {
    readMoreLink = (
      <button type="button" className="read-more-button" onClick={toggleCollapseClass}>
        {moreLessLabel()}
      </button>
    )
  }

  let subTextComp
  if ((subText && subText?.subText?.trim().length) || subText?.trim().length) {
    // this hook transform subText markdown to richtext
    useEffect(() => {
      async function getDocument() {
        const text = subText?.subText ? subText.subText : subText
        const richTextDocument = await richTextFromMarkdown(text)
        setDocument(richTextDocument)
      }
      getDocument()
    }, [])

    if (quote) {
      const array = quotesConverter(subText)
      const phrase = array[0].toUpperCase()
      const author = array[1]
      subTextComp = (
        <div className={subTextClass}>
          <p className={`quote-paragraph mobile-${contentAlignClassMobile}`}>{phrase}</p>
          {author ? (
            <>
              <br />
              <p className="author">{author}</p>
            </>
          ) : (
            ''
          )}
        </div>
      )
    } else {
      const options = subtextOptions(isBlog, blog, subTextClass, blogLink)
      subTextComp = documentToReactComponents(document, options)
    }
  }

  let decoration
  if (decorationBlockCard) {
    decoration = (
      <BlockCardImage
        imgData={data}
        columns={columns}
        showcaseCircles={!!showcaseCircles}
        gridLeadershipDesign={gridLeadershipDesign}
      />
    )
  }
  let imageBetweenContent
  if (mobileImageLocation) {
    if (mobileImageLocation.includes('Between')) {
      imageBetweenContent = (
        <div className="mobile">
          <BlockCardImage
            imgData={data}
            columns={columns}
            showcaseCircles={!!showcaseCircles}
            gridLeadershipDesign={gridLeadershipDesign}
          />
        </div>
      )
    }
  }

  let contactHours
  if (contactHoursText) {
    const options = contactHourOptions()
    contactHours = renderRichText(contactHoursText, options)
  }

  const contactHoursComp = contactHoursText ? (
    <div className="contact-hours"> {contactHours} </div>
  ) : (
    ''
  )

  let afterTextComp
  if (afterText && afterText.trim().length) {
    afterTextComp = (
      <p
        className="after"
        dangerouslySetInnerHTML={{
          __html: afterText
        }}
      />
    )
  }

  const containerInnerClass = columnsName => {
    if (columnsName === 'grid-two-columns') {
      return `two-colums__inner ${noPaddingCard(blockCardBox)}`
    }
    if (showcaseCircles || quote) {
      return `container__inner ${backgroundColorDiv(showcaseCircles, quote)} ${noPaddingCard(
        blockCardBox
      )}`
    }
    if (imageGrid) {
      return `container__inner bg-image-box ${backgroundColorDiv(showcaseCircles, quote)}`
    }
    if (gridLeadershipDesign || activeLeadershipDesign) {
      return `container__inner ${noPaddingCard(blockCardBox)} leadership-div-text`
    }
    return `container__inner ${noPaddingCard(blockCardBox)}`
  }

  let outterClasses = ['container__outter', contentAlignClass]

  let imageBox
  if (imageGrid && !quote) {
    imageBox = 'no-mg image-bg-box'
  }
  if (imageGrid && quote) {
    imageBox = 'no-mg image-quote-bg-box'
  }
  if (!imageGrid && quote) {
    imageBox = 'no-bg-image-quote-box'
  }

  if (activeLeadershipDesign) {
    outterClasses = ['container__outter leadership-general-box', contentAlignClass]
  }
  if (grid) {
    outterClasses = [`cards-grid ${imageBox}`, textAligner(contentAlignClass), blogTextColorClass]
  }
  if (backgroundImage || backgroundImageMobile) {
    outterClasses = ['container__outter section-hero', contentAlignClass]
  }
  if (ods) {
    outterClasses = ['container__outter section-hero ods', contentAlignClass]
  }

  if (mobileImageLocation && mobileImageLocation.includes('Below')) {
    outterClasses = ['container__outter mobile-image-layout', contentAlignClass]
  }

  if (theme && theme !== 'Dark Blue (Default)') {
    outterClasses.push(theme.toLowerCase().replaceAll(' ', '-'))
  }

  let disclaimerComp
  if (disclaimerText?.disclaimerText)
    disclaimerComp = (
      <p
        className="disclaimer"
        dangerouslySetInnerHTML={{
          __html: disclaimerText.disclaimerText
        }}
      />
    )
  let quoteBox

  if (quote && imageGrid === null) {
    quoteBox = 'quote-box'
  }
  if (quote && imageGrid) {
    quoteBox = 'quote-box-blue-bg'
  }

  let gridContent = (
    <div className="intro">
      {headlineComp}
      {imageBetweenContent}
      {subTextComp}
    </div>
  )

  if (grid) {
    gridContent = (
      <div className={`intro ${openDiv ? 'expand' : 'collapse'}`}>
        {showcaseCircles ? showcaseTitleComp : subHeadlineComp}
        {imageGrid ? headlineComp : ''}
        {subTextComp}
        {contactHoursComp}
      </div>
    )
  }

  const title = blog || imageGrid ? '' : headlineComp

  let imageDiv
  if ((images && images !== null) || (backgroundImage && backgroundImage !== null)) {
    imageDiv = (
      <BlockCardImage
        imgData={data}
        columns={columns}
        showcaseCircles={!!showcaseCircles}
        gridLeadershipDesign={gridLeadershipDesign}
        noGridLeadershipDesign={activeLeadershipDesign}
        isContentBlog={isBlog || blog}
      />
    )
  }
  if (mobileImageLocation && mobileImageLocation.includes('Between')) {
    imageDiv = (
      <div className="desktop">
        <BlockCardImage
          imgData={data}
          columns={columns}
          showcaseCircles={!!showcaseCircles}
          gridLeadershipDesign={gridLeadershipDesign}
          noGridLeadershipDesign={activeLeadershipDesign}
        />
      </div>
    )
  }

  const content = (
    <div className={outterClasses.join(' ')}>
      {grid ? title : ''}
      {imageDiv}
      <div className={containerInnerClass(columns)}>
        {decoration}
        <div
          className={`content ${quoteBox} ${sectionHeroPadding} ${hasImageClass} ${hideImageMobileClass(
            hideImageMobile
          )}`}
        >
          {gridContent}
          <div className={`buttons ${buttonClass}`}>
            {(buttons || []).map(button =>
              backgroundImage ? (
                <ContentfulButtonV3
                  parentComponent={__typename}
                  data={button}
                  key={JSON.stringify(button)}
                  bgImage
                />
              ) : (
                <ContentfulButtonV3
                  parentComponent={__typename}
                  data={button}
                  key={JSON.stringify(button)}
                  grid
                />
              )
            )}
          </div>
          {afterTextComp}
          {disclaimerComp}
        </div>
        {readMoreLink}
      </div>
    </div>
  )
  if (useDivOutterContainer)
    return <div className={`block-card ${contentAlignClass}`}>{content}</div>

  return (
    <section
      className={`block-card ${backgroundImage || backgroundImageMobile ? 'blue-bg' : ''} ${
        theme === 'Navy' ? 'navy' : ''
      } ${contentAlignClass} ${boxAligner(contentAlignClass)} ${
        imageGrid && getSrc(imageGrid.image) ? 'blockCard-bg' : ''
      } ${activeLetsTalkDesign ? 'lets-talk' : ''}`}
    >
      {content}
    </section>
  )
}

BlockCardV3.defaultProps = {
  useDivOutterContainer: false,
  grid: false,
  columns: '',
  blog: false,
  showcaseCircles: false,
  cardNumber: 0,
  quote: false,
  imageGrid: null,
  gridLeadershipDesign: false,
  ods: null
}

BlockCardV3.propTypes = {
  data: PropTypes.object.isRequired,
  useDivOutterContainer: PropTypes.bool,
  grid: PropTypes.bool,
  columns: PropTypes.string,
  blog: PropTypes.bool,
  showcaseCircles: PropTypes.bool,
  cardNumber: PropTypes.number,
  quote: PropTypes.bool,
  imageGrid: PropTypes.object,
  gridLeadershipDesign: PropTypes.bool,
  ods: PropTypes.bool
}

export default BlockCardV3
